/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
import { Pipe, PipeTransform } from '@angular/core';
import { EmployeeModel } from '../../models/employee.model';

@Pipe({
  name: 'employeeSearch',
  standalone: false
})
export class EmployeeSearchPipe implements PipeTransform {
  transform(employees: EmployeeModel[] = [], searchTerm: string = ''): EmployeeModel[] {
    if (!searchTerm.trim()) {
      return employees;
    }

    const lowerCaseSearchTerm = searchTerm.toLowerCase();

    return employees.filter(
      (employee) =>
        employee.userName?.toLowerCase().includes(lowerCaseSearchTerm) ||
        employee.email?.toLowerCase().includes(lowerCaseSearchTerm)
    );
  }
}
